/* Painel do Gestor — escopo rede (papel 2) ou região (papel 3).

   Um único painel serve aos dois: o GestorPainelView já opera inteiramente em
   escopo de região quando `regiaoSel` está preenchido (ver D3.1 do plano).
   Para o administrador de regional passamos `regiaoFixa`, que ancora o painel
   na região do usuário e impede subir ao nível da rede — ele não deve ver KPIs
   da rede inteira nem o ranking das outras regiões.

   AppShell trocado pelo PainelShell (D7). */

import React, { useState } from "react";

import { GestorPainelView } from "./GestorPainel";
import { Breadcrumb } from "../../components/layout/Breadcrumb";
import PainelShell from "../../components/PainelShell";
import { PeriodoFiltro } from "../../components/PeriodoFiltro";
import { periodoInicial } from "../../lib/periodo";
import { useContextoIE } from "../../lib/useContextoIE";

export function GestorApp() {
  const { contexto, carregando, erro } = useContextoIE("gestor");
  const [periodo, setPeriodo] = useState(periodoInicial);
  const [anoFiltro, setAnoFiltro] = useState(undefined);
  const [breadcrumb, setBreadcrumb] = useState([]);

  if (carregando) {
    return (
      <PainelShell escopoLabel="Rede" escopoValor="carregando…">
        <p className="text-[13px] text-[var(--color-ink-faint)]">Carregando…</p>
      </PainelShell>
    );
  }
  // Sem grupo NÃO é erro para quem tem escopo "todos" (Administrador
  // Educandus): é o "Todos" do modal do AVA, e significa a base inteira — as
  // chamadas saem sem `grupo_id` e o backend, irrestrito, devolve tudo. Exigir
  // grupo aqui era o que fazia o painel dele responder "não foi possível
  // identificar a sua rede" mesmo com a rede escolhida, porque o vínculo de
  // tipo G é vazio de propósito (33 de 33 sem group_id, medido em 04/08/2026).
  const semRede = !contexto?.grupoId && contexto?.escopo !== "todos";

  if (erro || semRede) {
    return (
      <PainelShell escopoLabel="Rede" escopoValor="carregando…">
        <p className="text-[13px] text-[var(--color-bad)]">
          {erro || "Não foi possível identificar a sua rede."}
        </p>
      </PainelShell>
    );
  }

  const regional = contexto.regiaoFixa;

  // Sem rede escolhida, o nível é a Educandus — e o rótulo diz isso, em vez de
  // "REDE | Todas as redes". Assim que uma rede é escolhida (no modal ou no
  // ranking), o breadcrumb do painel assume e este rótulo sai de cena.
  const escopoLabel = regional
    ? "Região"
    : contexto.grupoId
    ? "Rede"
    : "Educandus";

  return (
    <PainelShell
      escopoLabel={escopoLabel}
      escopoValor={regional ? contexto.regiaoNome : contexto.grupoNome}
      breadcrumb={
        breadcrumb.length > 1 ? <Breadcrumb items={breadcrumb} /> : null
      }
      toolbar={
        <PeriodoFiltro estado={periodo} ano={anoFiltro} onChange={setPeriodo} />
      }
    >
      <GestorPainelView
        // `educandus` liga o degrau das REDES, acima da rede. Vem do escopo do
        // papel, não da ausência de grupo: o Administrador Educandus que
        // escolheu uma rede no modal continua podendo subir e comparar as
        // outras — a escolha é ponto de partida, não recorte permanente.
        educandus={contexto.escopo === "todos"}
        grupoId={contexto.grupoId}
        grupoNome={contexto.grupoNome}
        regiaoFixa={
          regional
            ? { id: contexto.regiaoId, regional: contexto.regiaoNome }
            : null
        }
        periodo={periodo}
        onAno={setAnoFiltro}
        onBreadcrumb={setBreadcrumb}
      />
    </PainelShell>
  );
}
